module.exports = require("@noble/curves/secp256k1");